import { requestFactory } from '../../RequestFactory';
import { path } from '../../Paths';
import { requestMethods } from '../../../../Constants/requestMethods';
import { toFormData } from '../../../../Utils';

export const getClassesByDateRange = (startDate, endDate) => {
    const url = path.create().getClassesByDateRange(startDate, endDate);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const updateClassSeries = (seriesId, data) => {
    const url = path.create().updateClassSeries(seriesId);

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toFormData(data),
    };

    return requestFactory.createRequest(requestConfig);
};

export const deleteClassSeries = seriesId => {
    const url = path.create().deleteClassSeries(seriesId);

    const requestConfig = {
        url,
        method: requestMethods.DELETE,
    };

    return requestFactory.createRequest(requestConfig);
};

export const deleteClass = classId => {
    const url = path.create().deleteClass(classId);

    const requestConfig = {
        url,
        method: requestMethods.DELETE,
    };

    return requestFactory.createRequest(requestConfig);
};

export const bookClass = classId => {
    const url = path.create().bookClass(classId);

    const requestConfig = {
        url,
        method: requestMethods.POST,
    };

    return requestFactory.createRequest(requestConfig);
};

export const cancelClassBooking = classId => {
    const url = path.create().cancelClassBook(classId);

    const requestConfig = {
        url,
        method: requestMethods.POST,
    };

    return requestFactory.createRequest(requestConfig);
};



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/ClassesApi/classesRequestConfigs.js